/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { resolveCssColor } from './ColorTools.js';
/**
 * Creates a line-color provider for grids associated with value axes
 */

export function createValuesGridLineColorProvider() {
  const gridLineColor = _resolveGridLineColor();

  const gridLineColorAt0 = resolveCssColor('var(--davinci-color-background-elements-3)');
  return {
    lineColor(value) {
      return value === 0.0 ? gridLineColorAt0 : gridLineColor;
    }

  };
}
/**
 * Creates the default grid style for value axes
 * @param gridIsVisible - whether the grid is visible (true) or not (false)
 */

export function createValuesGridStyle(gridIsVisible) {
  const gridStyle = {};
  gridStyle.lineColors = createValuesGridLineColorProvider();
  gridStyle.visible = gridIsVisible;
  return gridStyle;
}
/**
 * Creates a line-color provider for grids associated with category axes
 */

export function createCategoriesGridLineColorProvider() {
  const gridLineColor = _resolveGridLineColor();

  return {
    lineColor() {
      return gridLineColor;
    }

  };
}
/**
 * Creates the default grid style for value axes
 * @param gridIsVisible - whether the grid is visible (true) or not (false)
 */

export function createCategoriesGridStyle(gridIsVisible) {
  const gridStyle = {};
  gridStyle.lineColors = createCategoriesGridLineColorProvider();
  gridStyle.visible = gridIsVisible;
  return gridStyle;
}

function _resolveGridLineColor() {
  return resolveCssColor('var(--davinci-color-background-elements-1)');
}
